"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../../composite/table/table-cells");
const table_filter_cells_1 = require("../../../composite/table/table-filter-cells");
const ess_api_1 = require("../ess-api");
/**
 * fixme: add document, subject
 */
function useColumns() {
    const intl = react_intl_1.useIntl();
    return [
        {
            datakey: 'state',
            name: intl.formatMessage({
                id: 'ESS_DISPATCHES_COLUMN_STATE',
                defaultMessage: 'Stav',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(ess_api_1.useDispatchStates),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(ess_api_1.useDispatchStates),
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'method',
            name: intl.formatMessage({
                id: 'ESS_DISPATCHES_COLUMN_METHOD',
                defaultMessage: 'Způsob odeslání',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(ess_api_1.useDispatchMethods),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(ess_api_1.useDispatchMethods),
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=dispatches-columns.js.map